import { CPUtils } from "./Utils";


let curScrollPos = 0
let oldScroll = 0
export default {
    name: 'CPLink',
    props: ['url', 'message_id', 'response'],
    data (){
      return {
      }
    },
    updated(){
      let container = document.querySelector("#chat_queue")
      curScrollPos = container.scrollTop;
      oldScroll = container.scrollHeight - container.clientHeight;
      this.$nextTick(function () {
        if(this.$el.nodeName == "DIV"){
          let container = document.querySelector("#chat_queue")
          let total = container.scrollHeight - container.clientHeight - container.scrollTop
          if(total < container.clientHeight)
            CPUtils.ScrollChatMessagesToEnd()
          
            
        }        
      })          
    }
}
